module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09HL684SS.cc9bbf22.jpg";